import Link from 'next/link';

export default function Navigation()  {
  return (
    <nav className="fixed top-0 w-full bg-sage-dark/90 backdrop-blur-sm z-50 border-b border-sage/20">
      <div className="container mx-auto px-4 py-4">
        <ul className="flex justify-center space-x-8 font-crimson-seven text-white">
          <li><Link href="/" className="hover:text-sage-light transition-colors">Home</Link></li>
          <li><Link href="/venue" className="hover:text-sage-light transition-colors">Venue</Link></li>
          <li><Link href="/travel" className="hover:text-sage-light transition-colors">Where to Stay</Link></li>
          <li><Link href="/registry" className="hover:text-sage-light transition-colors">Registry</Link></li>
          <li><Link href="/schedule" className="hover:text-sage-light transition-colors">Schedule</Link></li>
        </ul>
      </div>
    </nav>
  );
};

